import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Mostrar loading enquanto verifica autenticacao
  if (loading) {
    return (
      <div className="min-h-screen bg-neutral-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500 mx-auto mb-4"></div>
          <p className="text-lg text-neutral-600">Verificando acesso...</p>
          <div className="mt-2">
            <div className="text-2xl font-bold">
              <span className="text-primary-500">mara</span>
              <span className="text-dark-700 ml-1 font-light">Labs</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Se nao estiver autenticado, redirecionar para login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Se estiver autenticado, renderizar o componente
  return children;
};

export default ProtectedRoute;